import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import BonusProgressBar from 'components/ClientProfile/Bonuses/DepositBonuses/BunusesItemExpand/BonusProgressBar';
import { bonusStatuses } from 'common/constants';
import BonusTableListItemExpandTable from './BonusTableListItemExpandTable';

const { ACTIVATED, PENDING } = bonusStatuses;

const BonusTableListItemExpandInfo = ({ bonus, wallet }) => {
  const { status } = bonus;

  const renderDateFunc = useCallback(() => {
    if (status !== ACTIVATED && status !== PENDING && status !== undefined) {
      return <BonusProgressBar bonus={bonus} />;
    }
  }, [status]);

  return (
    <>
      <div className="bonus-info-expanded-info">
        <BonusTableListItemExpandTable bonus={bonus} wallet={wallet} />
      </div>
      {renderDateFunc()}
    </>
  );
};

BonusTableListItemExpandInfo.propTypes = {
  bonus: PropTypes.object.isRequired,
  wallet: PropTypes.object.isRequired,
};

export default BonusTableListItemExpandInfo;
